import { z } from "zod";

export const MAX_DESCRICAO_DO_SERVICO = 500;
export const descricaoDoServicoSchema = z.string().trim().max(MAX_DESCRICAO_DO_SERVICO).nullable();

/** A foto chega reduzida pelo navegador (lado maior 480px, JPEG); o teto só barra quem pulou a redução. */
export const MAX_IMAGEM_DO_SERVICO = 400_000;
export const salvarImagemDoServicoSchema = z.object({
  serviceCategoryId: z.string().min(1),
  /** Nulo tira a foto. */
  dataUrl: z
    .string()
    .regex(/^data:image\/(jpeg|png|webp);base64,/, "Formato de imagem não aceito.")
    .max(MAX_IMAGEM_DO_SERVICO, "Imagem muito grande.")
    .nullable(),
});
